export default {
	language: 'မြန်မာ',
	menu_1: 'ပင်မစာမျက်နှာ',
	menu_2: 'ကုန်ပစ္စည်းအသေးစိတ်',
	menu_3: 'အသုံးပြုရန်အဆင့်များ',
	menu_4: 'ကျွန်ုပ်တို့၏မီးမောင်းထိုးပြ',
	menu_5: 'ကြှနျုပျတို့အကွောငျး',
	menu_6: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ',
	menu_7: 'ကြှနျုပျတို့ကိုဆကျသှယျရနျ',
	banner_1: 'Credit Loan',
	banner_2: ' ကျွန်ုပ်တို့၏တာဝန်မှာ သုံးစွဲသူများအား ဘေးကင်းပြီး အဆင်ပြေသော ခရက်ဒစ်ဝန်ဆောင်မှုများပေးဆောင်ရန်ဖြစ်သည်။',
	step_1: 'ကုန်ပစ္စည်းအသေးစိတ်',
	step_2: '1. ချေးငွေ- နိုင်ငံသားစိစစ်ရေးကတ်ပြား ပါရှိသူဖြစ်ရမည်။',
	step_3: '2. အသက်: အသက် 20 ကျော်',
	step_4: '3. အရင်းအနှီး: အလုပ်အကိုင်နှင့် တည်ငြိမ်သော ၀င်ငွေအရင်းအမြစ်ရှိခြင်း။',
	product_1: 'အသုံးပြုရန်အဆင့်များ',
	product_2: '1. Credit Loanလျှောက်လွှာကို ဒေါင်းလုဒ်လုပ်ပြီး မိုဘိုင်းလ်ဖုန်းဖြင့် မှတ်ပုံတင်ပါ။',
	product_3: '2. ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို ဖြည့်သွင်းခြင်းဖြင့် ကာကွယ်နိုင်မည်ဖြစ်သည်။',
	product_4: '3. အတည်ပြုချက်ကို စောင့်နေသည်။',
	product_5: '4. စစ်ဆေးရေးပြီးနောက် ချေးငွေကို သင့်ဘဏ်အကောင့်သို့ တိုက်ရိုက်ထည့်သွင်းနိုင်သည်။',
	user_1: 'ကျွန်ုပ်တို့၏မီးမောင်းထိုးပြ',
	user_2: 'လျှို့ဝှက်အခကြေးငွေမရှိပါ (ပွင့်လင်းမြင်သာမှု)',
	user_3: 'အဆင်ပြေသောငွေပေးချေမှု (အွန်လိုင်းတွင် လည်ပတ်ပါ)',
	user_4: 'ဘေးကင်းပြီး ယုံကြည်စိတ်ချရသော (လုံခြုံစိတ်ချရသော အကြွေးဝန်ဆောင်မှု)',
	about_1: 'ကြှနျုပျတို့အကွောငျး',
	about_2: 'အတိုချုံးဖော်ပြချက်- ကျွန်ုပ်တို့၏တာဝန်မှာ သုံးစွဲသူများအား ဘေးကင်းပြီး အဆင်ပြေသော ခရက်ဒစ်ဝန်ဆောင်မှုများပေးဆောင်ရန်ဖြစ်သည်။',
	about_3: 'သင့်တွင် မေးခွန်းများ သို့မဟုတ် Credit Loanများအကြောင်း ပိုမိုသိရှိလိုပါက အောက်ပါနည်းလမ်းများဖြင့် ကျွန်ုပ်တို့ထံ ဆက်သွယ်ပါ။',
	footer_1: 'ကြှနျုပျတို့ကိုဆကျသှယျရနျ',
	footer_2: 'အလုပ်ချိန်- တနင်္လာ-သောကြာ 09.00-18.00',
	footer_3: 'huststorager.linyi@gmail.com',
	footer_4: '75/102 Ocean Tower 2, 37th Floor, Sukhumvit Soi 19,Bangkok 10110 Thailand',
	footer_5: 'Credit Loan',
	privacy: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ',
	del_data_1: 'သင့်ဒေတာ၏ ဘေးကင်းမှုကို သေချာစေရန် ဒေတာဖျက်ခြင်း လုပ်ဆောင်ချက်ကို အသုံးပြုခြင်း။ မင်းအထောက်အထားကို စိစစ်ရမယ်',
	del_data_2: 'ကျေးဇူးပြု၍ သင့်မိုဘိုင်းဖုန်းနံပါတ်ကို ထည့်ပါ',
	del_data_3: 'ကျေးဇူးပြု၍ သင့်ဖုန်းနံပါတ်ကို ထည့်ပါ',
	del_data_4: 'ကျေးဇူးပြု၍ သင့်အက်ပ်စကားဝှက်ကို ထည့်ပါ',
	del_data_5: 'နောက်တစ်ဆင့်',
	del_data_6: 'လေးစားရပါသော အသုံးပြုသူ',
	del_data_7: 'မင်္ဂလာပါ။ အက်ပ်ကိုအသုံးပြုရန် ရွေးချယ်သည့်အတွက် ကျေးဇူးတင်ရှိပါသည်။ ဘတ်ကို လွယ်လွယ်နဲ့ ရအောင်ယူ၊',
	del_data_8: 'အကောင့်ဖျက်ရန် မလျှောက်ထားမီ သင့်မှာယူမှုအားလုံးကို ငွေပေးချေပြီးကြောင်း သေချာပါစေ။ လောလောဆယ် စစ်ဆေးဆဲ မှာယူမှုများ မရှိပါ။ ကျေးဇူးပြု၍ သင့်အကောင့်ကို ဖျက်လိုက်သည်နှင့်၊ ဒေတာကို ပြန်လည်ရယူရန် မဖြစ်နိုင်ပါ။ အသုံးမပြုမီ ဂရုတစိုက်အတည်ပြုပါ။ ဤအက်ပ်သည် ကိုယ်ရေးကိုယ်တာပစ္စည်းများ ဆုံးရှုံးခြင်းအတွက် တာဝန်မရှိပါ။',
	del_data_9: 'သင့်ဒေတာကို ဖျက်လိုကြောင်း အတည်ပြုပါက၊ ကျေးဇူးပြု၍ အောက်ပါခလုတ်ကိုနှိပ်ပါ၊',
	del_data_10: 'ဖျက်ကြောင်း အတည်ပြုပါ',
	del_data_11: 'သင်၏အထောက်အထားကို အတည်ပြုရန် အတည်ပြုကုဒ်ကို ထည့်ပါ။',
	del_data_12: 'ဂဏန်း 4 လုံး အတည်ပြုကုဒ်ကို ထည့်ပါ',
	del_data_13: 'ထပ်မံတင်ပြပါ',
	del_data_14: 'အိုကေ',
	del_data_15: 'သင့်ဒေတာကို ဖျက်လိုက်ပါပြီ။',
	del_data_16: 'ID Card အတည်ပြုခြင်း',
	del_data_17: 'ကျေးဇူးပြု၍ သင်၏ ID ကတ်ကို ထည့်ပါ',
	del_data_18: 'စိစစ်နေသည်',
}
